import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ChatState } from './chat.state';

/**
 * Definición del selector
 */
export const selectChatState = createFeatureSelector<ChatState>('chat');

export const getScheduleMessage = createSelector(selectChatState, (state: ChatState) => state.scheduleMessage);
export const getIsActive = createSelector(selectChatState, (state: ChatState) => state.active);
export const getIsEnabled = createSelector(selectChatState, (state: ChatState) => state.enabled);
export const getHubtype = createSelector(selectChatState, (state: ChatState) => state.hubType);
export const getUrlChat = createSelector(selectChatState, (state: ChatState) => state.urlChat);
export const getKakaoTalk = createSelector(selectChatState, (state: ChatState) => state.kakaoTalk);
export const getMochaChat = createSelector(selectChatState, (state: ChatState) => state.mochaChat);
export const getStyleAdvisor = createSelector(selectChatState, (state: ChatState) => state.styleAdvisor);
export const getEnabledChats = createSelector(selectChatState, (state: ChatState) => state.enabledChats);
export const selectChatVisible = createSelector(selectChatState, (state: ChatState) => state?.visible);
export const selectActiveChat = createSelector(selectChatState, (state: ChatState) => state?.activeChat);
export const selectChatOpened = createSelector(selectChatState, (state: ChatState) => state.opened);
export const selectHubtypeLoaded = createSelector(selectChatState, (state: ChatState) => state?.hubType?.loaded);
export const selectChatHtmlLoaded = createSelector(selectChatState, (state: ChatState) => state.htmlLoaded);
export const selectChatWidgetLoaded = createSelector(selectChatState, (state: ChatState) => state.widgetLoaded);
export const selectIsLargeButtonChat = createSelector(selectChatState, (state: ChatState) => state?.isLargeButtonChat);
export const showChatButton = createSelector(selectChatState, (state: ChatState) => state.isButtonVisible);
